<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <NavMenu id="nav"></NavMenu>
    <carousel id="news"></carousel>
    <Parallax id="about"></Parallax>
    <card id="services"></card>
    <AutoPlay id="highlights"></AutoPlay>
    <Partners id="partners"></Partners>
    <!-- 临时联系我们 Begin -->
    <div class="Contact">
      <el-button class="contact-button" type="primary" @click="contactDialogVisible = true">联 系 我 们<br>CONTACT
        US</el-button>
      <el-dialog class="el-dialog-container" v-model="contactDialogVisible" width="66vw" :append-to-body="true"
        align-center style="font-family: 'FangYuan'" destroy-on-close>
        <ContactVue></ContactVue>
        <!-- <span>Open the dialog from the center from the screen</span> -->
      </el-dialog>
    </div>
    <!-- 临时联系我们 End -->
  </div>
  <!-- <div class="footer"><span><p># 国际 STEM 竞赛 - F1 在学校（F1 in Schools）中国官方合作机构</p><br><p><a href="https://beian.miit.gov.cn" target="_blank" rel="noopener">沪ICP备2024060180号-1</a></p><p><a href="https://beian.mps.gov.cn/#/query/webSearch?code=31011202020236" rel="noreferrer" target="_blank"><img alt="备案图标" src="data:image/png;base64,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" style="height: 3.25vmin; align-items: center; vertical-align: middle;">沪公网安备31011202020236号</a></p><p>违法和不良信息举报：abuse@s7edu.com</p><p>Copyright &copy; <a href="https://www.s7edu.com">上海圣七教育科技有限公司</a>. All rights reserved.</p></span></div> -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';
import AutoPlay from '@/components/AutoPlay.vue';
import card from '@/components/CardVue.vue';
import carousel from '@/components/Carousel.vue';
import NavMenu from '@/components/NavMenu.vue';
import Parallax from '@/components/Parallax.vue';
import Partners from '@/components/Partners.vue';
import ContactVue from '@/components/ContactVue.vue';

export default {
  name: 'HomeView',
  // 临时联系我们
  data() {
      return {
          contactDialogVisible: false,
      };
  },
  components: {
    // HelloWorld,
    NavMenu,
    carousel,
    Parallax,
    card,
    AutoPlay,
    Partners,
    ContactVue,  // 临时联系我们
  }
}
</script>

<style>
/* 临时联系我们 Begin */
.contact-button {
  font-family: 'ShuHei';
  font-weight: normal;
  font-size: 3vmin;
  height: auto;
  width: auto;
  padding: 2vmin 8vmin;
  line-height: 4vmin;
}

.Contact {
  margin: 6vw 0vw;
}

/* @media screen and (max-width: 768px) {
    .Contact .el-dialog {
        --el-dialog-width: 85vw !important;
    } 
} */
/* 临时联系我们 End */

/* 对话框竖屏增大 */
@media screen and (max-width: 768px) {
  .el-dialog-container {
    --el-dialog-width: 85vw !important;
  }
}

.footer a {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.footer p {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.footer {
  margin-top: 3vw;
  
  background-color: rgba(0, 0, 255, 0.2);
  color: #513890;
  text-align: center;
  font-family: 'ShuHei';
  font-size: 2.5vmin;
  font-weight: normal;
  line-height: 3.75vmin;
  padding: 4.25vmax 2vw;
  margin: 0;
}

body {
  margin-top: 0;
}
</style>
